import React from 'react'
import Fhoto01 from '../assets/Photo01.png'
import Fhoto02 from '../assets/Photo02.png'
import Fhoto03 from '../assets/Photo03.png'
import Fhoto04 from '../assets/PhotoSF/Pt04-removebg-preview.png'
import Fhoto05 from '../assets/PhotoSF/Pt05-removebg-preview.png'


const Gallery = () => {
	return (
		<div className='py-12 flex flex-wrap justify-center md:justify-between mx-10 md:mx-10 lg:mx-20 xl:mx-40 '>
			<div class="py-5 px-5 gallery autoplay items-3">
				<div id="item-1" class="control-operator"></div>
				<div id="item-2" class="control-operator"></div>
				<div id="item-3" class="control-operator"></div>
				
				
					
				
				
					
				<figure class="item">
					<h1><img src={Fhoto01} alt='Photo01' /></h1>
						
				</figure>

				<figure class="item">
					<h1><img src={Fhoto02} alt='Phot02' /></h1>
							
				</figure>

				<figure class="item">
					<h1><img src={Fhoto03} alt='Photo03' /></h1>
							
				</figure>
			

				
					
					

				<div class="controls">
					<a href="#item-1" class="control-button">•</a>
					<a href="#item-2" class="control-button">•</a>
					<a href="#item-3" class="control-button">•</a>
					
					
						
				</div>

			</div>
		</div>
				
		
			
		
	)
}

export default Gallery